import { TypedPocketBase } from "../generated/pocketbase";
import { SITE_URL } from "./config";
import PocketBase from "pocketbase";

export const pb = new PocketBase(SITE_URL).autoCancellation(
  false
) as TypedPocketBase;
